import styled from "styled-components";

const TRANSITION_DURATION = "300ms";
const TRANSITION_TIMING_FUNCTION = "ease-in-out";

export const StyledCheckBoxInput = styled.input`
	border-radius: ${({ theme }) => theme.radii.sm};

	:checked + .CheckBox__circle {
		.Icon {
			opacity: 1;
		}
	}
`;

export const StyledCheckBoxCircle = styled.span`
	border-radius: ${({ theme }) => theme.radii.xs};

	.Icon {
		opacity: 0;
		transition: opacity ${TRANSITION_DURATION} ${TRANSITION_TIMING_FUNCTION};
	}

	:hover {
		.Icon {
			opacity: 1;
		}
	}
`;
